import { useEffect, useRef } from 'react';
import useUserPlatform, { useUserHints } from '@/hooks/use-user-platform';

const useIosScrollByAdjustment = (scrollContainerId: string, flag?: boolean) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const { isIOS } = useUserPlatform();
  const { hints } = useUserHints();
  const iOSVersion = Number.parseFloat(hints.browserVersion ?? '0');

  useEffect(() => {
    if (!isIOS || iOSVersion < 17 || !flag) return;

    const virtuosoContainer = document.getElementById(scrollContainerId);

    if (!virtuosoContainer) return;

    containerRef.current = virtuosoContainer as HTMLDivElement;

    const originalScrollBy = containerRef.current.scrollBy;

    // Override the scrollBy method
    containerRef.current.scrollBy = function (optionsOrX?: number | ScrollToOptions, y?: number): void {
      if (typeof optionsOrX === 'object') {
        const { top, left, behavior } = optionsOrX;

        // on iOS, the actual scrollBy value is double the value passed in
        originalScrollBy.apply(this, [{ top: top && top / 2, left, behavior }] as any);
      } else {
        originalScrollBy.call(this, optionsOrX!, y!);
      }
    };

    return () => {
      if (containerRef.current) {
        containerRef.current.scrollBy = originalScrollBy;
      }
    };
  }, [isIOS, scrollContainerId, iOSVersion, flag]);
};
export default useIosScrollByAdjustment;
